export default {
	created() {
		this.uuid = Math.random()
			.toString(36)
			.substring(3, 8);
	}
};



// WEBPACK FOOTER //
// ./~/@58fe/v5/src/mixins/uuid.js